import BaseCommand from "@/models/api/commands/BaseCommand";

export class CopyRequiredAttributesCommand extends BaseCommand {
  CommandName = "CopyRequiredAttributeToAllBookingItem";
  Command: { BookingItemTmpId: string };
  constructor(sessionId: string, operationId: string, bookingItemTmpId: string) {
    super(sessionId, operationId);
    this.Command = { BookingItemTmpId: bookingItemTmpId };
  }
}
